import React, { useRef, useEffect } from 'react';
import Draggable from 'react-draggable';
import { useModal } from '../../context/ModalContext';
import Icon from '../common/Icon';
import { icons } from '../../config/icons';

const ModalInstance = ({ modal, closePopup, isTopModal }) => {
    const { id, widthClass, title, content, actions, animation, closeOnBackdropClick, isDraggable, isAlert, style, duration } = modal;
    const nodeRef = useRef(null);

    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => { closePopup(id); }, duration);
            return () => clearTimeout(timer);
        }
    }, [duration, closePopup, id]);

    const handleBackdropClick = (e) => { 
        if (closeOnBackdropClick && e.target === e.currentTarget && isTopModal) { 
            closePopup(id); 
        } 
    };

    const renderIcon = () => {
        switch (style) {
            case 'success':
                return (<div className='alert-icon'><div className='alert-checkmark'> <div className='checkmark-stem'></div><div className='checkmark-kick'></div> </div></div>);
            case 'error':
                return (<div className='alert-icon'><div className='alert-error'> <div className='error-line left'></div><div className='error-line right'></div> </div></div>);
            case 'info':
                return (<div className='alert-icon'><div className='info-circle'><h5>i</h5></div></div>);
            case 'warning':
                return (<div className='alert-icon'><div className='warning-circle'><h5>!</h5></div></div>);
            default:
                return null;
        }
    };

    const modalPanel = (
        <div ref={nodeRef} className={`modal-panel ${widthClass} ${!isTopModal ? 'modal-background-stack' : ''}`}>
            <div className={`modal-content-wrapper modal-animation-${animation}`}>
                {isAlert === false ? (
                    <>
                        <header className='modal-header'> <h2>{title === '' ? 'Pop-up Form' : title}</h2> <button onClick={() => closePopup(id)} className='modal-close-btn' disabled={modal.isLoading}>&times;</button> </header>
                        <main className='modal-content'> {content} </main>
                        <div className="modal-portal-target"></div>
                        {actions && actions.length > 0 && (
                            <footer className='modal-actions'>
                                {actions.map((action, index) => {
                                    const isPrimary = action.className?.includes('btn-primary') || action.className?.includes('btn-danger') || (action.text && action.text.match(/save|update|create|yes|delete|archive|restore|unarchive/i));
                                    const showSpinner = modal.isLoading && isPrimary;
                                    return (
                                        <button key={index} onClick={() => { if(action.onClick) action.onClick(); }} className={`button ${action.className || ''}`} disabled={modal.isLoading} > 
                                            {showSpinner ? <Icon icon={icons.spinner} className="icon-spin" /> : (action.icon && <Icon icon={action.icon} />)} {action.text}
                                        </button>
                                    );
                                })}
                            </footer>)}
                    </>)
                    :
                    (<div className='alert-wrap'>
                        {renderIcon()}
                        {title !== '' ? (<div className='alert-title'><h2>{title}</h2></div>) : ''}
                        {content !== '' ? (<main className='alert-content'> {content} </main>) : ''}
                        <div className='alert-foot'> {actions.length <= 0 ? <button className='button' disabled={modal.isLoading} onClick={() => closePopup(id)} >OK</button> : actions.map((action, index) => {
                                    const isPrimary = action.className?.includes('btn-primary') || action.className?.includes('btn-danger') || (action.text && action.text.match(/save|update|create|yes|delete|archive|restore|unarchive/i));
                                    const showSpinner = modal.isLoading && isPrimary;
                                    return (
                                        <button key={index} onClick={() => { if(action.onClick) action.onClick(); }} className={`button ${action.className || ''}`} disabled={modal.isLoading} > 
                                            {showSpinner ? <Icon icon={icons.spinner} className="icon-spin" /> : (action.icon && <Icon icon={action.icon} />)} {action.text}
                                        </button>
                                    );
                        })} </div>
                    </div>)}
            </div>
        </div>);

    return (
        <div className='modal-backdrop' onClick={handleBackdropClick} style={{ zIndex: isTopModal ? 1000 : 999 }}>
            {isDraggable ? (
                <Draggable
                    nodeRef={nodeRef}
                    handle='.modal-header'
                    cancel='.modal-content, .modal-actions, .modal-close-btn'
                    positionOffset={{ x: '-50%', y: '-50%' }}
                >
                    {modalPanel}
                </Draggable>
            ) : (modalPanel)}
        </div>
    );
};

const Modal = () => {
    const { modals, closePopup } = useModal();

    if (!modals || modals.length === 0) { return null; }

    return (
        <>
            {modals.map((modal, index) => (
                <ModalInstance 
                    key={modal.id} 
                    modal={modal} 
                    closePopup={closePopup} 
                    isTopModal={index === modals.length - 1} 
                />
            ))}
        </>
    );
};

export default Modal;